/* eslint-disable import/no-default-export */
import { Action, actionCreator } from 'app/gamma/src/util/actions';
import { createReducer } from 'app/gamma/src/util/reducers';

const NAVIGATE_START = Symbol('ui/NAVIGATE_START');
const NAVIGATE_STOP = Symbol('ui/NAVIGATE_STOP');

type NavigateStartAction = Action<typeof NAVIGATE_START, null>;
type NavigateStopAction = Action<typeof NAVIGATE_STOP, null>;

export type NavigatingState = boolean;

const initialState: NavigatingState = false;

export default createReducer(initialState, {
  [NAVIGATE_START]() {
    return true;
  },

  [NAVIGATE_STOP]() {
    return false;
  },
});

export const navigateStart = actionCreator<NavigateStartAction>(NAVIGATE_START);
export const navigateStop = actionCreator<NavigateStopAction>(NAVIGATE_STOP);
